import Image from 'next/image'
import Link from 'next/link'
import {
    FaArrowRight,
    FaBrain,
    FaBoxes,
    FaChartLine,
    FaCode,
    FaCogs,
    FaPalette,
    FaPython,
    FaRocket,
    FaSearch,
    FaServer,
    FaSyncAlt,
    FaTachometerAlt,
    FaUserCog,
} from 'react-icons/fa'
import { CiCloudSun } from 'react-icons/ci'
import CloudastraLogoBlack from '../public/Cloudastra-Logo-big.png' //black text
import medAI from '../public/products/k1.png'
import nigmaBot from '../public/products/k2.png'
import riskIntel from '../public/products/riskintels.png' 
import integraAI from '../public/products/k8.png'
import CloudastraLogoWhite from '../public/white-cloud.png' //white text
import MobileNav from './MobileNav'
import NavItem from './NavItem'
import TravelB2BImage from '/public/products/k5.png'
import aquatap from '/public/products/k9.png'
import secureFlow from '/public/products/sf.png'
import complianceImage from '/public/products/cp.png'
import revinuImg from '/public/products/rv.png'
import debtPulseImg from '/public/products/dp.png'
import mulenetImg from '/public/products/mulenet.png'
import { usePathname } from 'next/navigation'
import { startTransition, useEffect, useState } from 'react'
import { Phone } from 'lucide-react'

const navbarData = [
    {
        id: 'nav-7',
        label: 'AI-First Engineering',
        href: '/ai-first-engineering/hire-ai-engineer',
        type: 'link',
        isDropdown: true,
        dropdown: [
            {
                id: 'sub-1',
                sub_section_label: 'Assess & Build',
                sub_section_items: [
                    {
                        id: 'link-1',
                        label: 'AI-First Architecture Audit',
                        heading: 'AI-First Architecture Audit',
                        subheading: 'Find the gaps before you build.',
                        href: '/ai-first-engineering/architecture-audit',
                        icon: <FaSearch />,
                    },
                    {
                        id: 'link-2',
                        label: 'AI-First MVP Build',
                        heading: 'AI-First MVP Build',
                        subheading: 'Ship a real product in weeks.',
                        href: '/ai-first-engineering/mvp-build',
                        icon: <FaRocket />,
                    },
                    {
                        id: 'link-3',
                        label: 'AI-First Product Engineering',
                        heading: 'AI-First Product Engineering',
                        subheading: 'AI-native products from day one.',
                        href: '/ai-first-engineering/product-engineering',
                        icon: <FaBoxes />,
                    },
                ],
            },
            {
                id: 'sub-2',
                sub_section_label: 'Modernize & Scale',
                sub_section_items: [
                    {
                        id: 'link-4',
                        label: 'AI-First System Modernization',
                        heading: 'AI-First System Modernization',
                        subheading: 'Bring legacy systems into the AI era.',
                        href: '/ai-first-engineering/system-modernization',
                        icon: <FaSyncAlt />,
                    },
                    {
                        id: 'link-5',
                        label: 'AI Infrastructure Optimization',
                        heading: 'AI Infrastructure Optimization',
                        subheading: 'Faster systems, lower cloud bills.',
                        href: '/ai-first-engineering/infrastructure-optimization',
                        icon: <FaTachometerAlt />,
                    },
                    {
                        id: 'link-6',
                        label: 'AI-First Growth Engine',
                        heading: 'AI-First Growth Engine',
                        subheading: 'Turn AI into compounding growth.',
                        href: '/ai-first-engineering/growth-engine',
                        icon: <FaChartLine />,
                    },
                ],
            },
            {
                id: 'sub-3',
                sub_section_label: 'Leadership',
                sub_section_items: [
                    {
                        id: 'link-7',
                        label: 'Fractional AI-First CTO',
                        heading: 'Fractional AI-First CTO',
                        subheading: 'Senior AI leadership, on demand.',
                        href: '/ai-first-engineering/fractional-cto',
                        icon: <FaUserCog />,
                    },
                ],
            },
        ],
    },
    {
        id: 'nav-4',
        label: 'Products',
        href: '/products',
        type: 'images',
        isDropdown: true,
        dropdown: {
            heading: 'Our Products',
            links: [
                {
                    id: 0,
                    label: 'iPreferAir',
                    href: '/products/b2b-travel',
                },
                {
                    id: 1,
                    label: 'Integra-AI',
                    href: '/products/integra-ai',
                },
                {
                    id: 2,
                    label: 'DebtPulse',
                    href: '/products/debtpulse',
                },
                {
                    id: 3,
                    label: 'SecureFlow',
                    href: '/products/secure-flow',
                },
               
                {
                    id: 4,
                    label: 'RiskIntel',
                    href: '/products/riskintel',
                },
                {
                    id: 5,
                    label: 'MuleNet',
                    href: '/products/mulenet',
                },

                
                 {
                    id: 6,
                    label: 'Compliance',
                    href: '/products/compliance',
                },
                {
                    id: 7,
                    label: 'Aquaflowz',
                    href: 'https://aquaflowz.cloudastra.co/',
                    target: '_blank',
                },

            ],
            images: [
                {
                    id: 0,
                    src: TravelB2BImage,
                    description:
                        'A robust B2B travel booking platform offering real-time inventory, advanced management tools and seamless operations for travel agencies.',
                },
                {
                    id: 1,
                    src: integraAI,
                    description:
                        'A simple AI chat platform with a clean, conversation-style interface. Bring your own API keys and connect to models like GPT-4, Claude and DeepSeek.',
                },
                {
                    id: 2,
                    src: debtPulseImg,
                    description:
                        'AI-powered digital collections platform for NBFCs and fintech lenders — prioritize high-risk accounts, automate compliant outreach, and improve recovery rates.',
                },
                {
                    id: 3,
                    src: secureFlow,
                    description:
                        'A high-performance fraud detection pipeline that processes millions of transactions in real time with sub-millisecond latency.',
                },
                
                {
                    id: 4,
                    src: riskIntel,
                    description:
                        'A comprehensive risk management platform that helps businesses identify, assess and mitigate risks effectively.',
                },
                {
                    id: 5,
                    src: mulenetImg,
                    description:
                        'Real-time transaction scoring and graph-native mule ring detection with regulator-ready evidence packs, built for India\'s Payment Aggregators and Payment Gateways.',
                },
                {
                    id: 6,
                    src: complianceImage,
                    description:
                        'Implement controls in your cloud, automate evidence collection, and support audits end-to-end for SOC 2, ISO 27001, and PCI DSS.',
                },
                {
                    id: 7,
                    src: aquatap,
                    description:
                        'AI-powered water quality monitoring and management system that ensures safe and clean water through real-time analysis and predictive insights.',
                },

            ],
        },
    },
    {
        id: 'nav-3',
        label: 'Services',
        href: '/services',
        type: 'link',
        isDropdown: true,
        dropdown: [
            {
                id: 'sub-1',
                sub_section_label: 'AI',
                sub_section_items: [
                    {
                        id: 'link-1',
                        label: 'AI Development & Consulting',
                        heading: 'AI Development & Consulting',
                        subheading: 'Custom models, RAG, agents and strategy',
                        href: '/services/ai-as-a-service',
                        icon: <FaBrain />,
                    },
                    {
                        id: 'link-2',
                        label: 'AI-First Engineering',
                        heading: 'AI-First Engineering programmes',
                        subheading: 'Audit, MVP build, modernisation, fractional CTO',
                        href: '/ai-first-engineering',
                        icon: <FaArrowRight />,
                    },
                ],
            },
            {
                id: 'sub-2',
                sub_section_label: 'Build',
                sub_section_items: [
                    {
                        id: 'link-1',
                        label: 'Web & App Development',
                        heading: 'Web & App Development',
                        subheading: 'Websites, portals and SaaS products',
                        href: '/services/custom-web-development-services',
                        icon: <FaCode />,
                    },
                    {
                        id: 'link-2',
                        label: 'Python Development',
                        heading: 'Python Development',
                        subheading: 'APIs, data pipelines and automation',
                        href: '/services/python-development-services',
                        icon: <FaPython />,
                    },
                    {
                        id: 'link-3',
                        label: 'UI / UX Design',
                        heading: 'UI / UX Design',
                        subheading: 'Research to design system',
                        href: '/services/ui-ux-design-services',
                        icon: <FaPalette />,
                    },
                ],
            },
            {
                id: 'sub-3',
                sub_section_label: 'Cloud & Operations',
                sub_section_items: [
                    {
                        id: 'link-1',
                        label: 'Managed Cloud & DevOps',
                        heading: 'Managed Cloud & DevOps',
                        subheading: 'Infrastructure, pipelines and on-call, run for you',
                        href: '/services/cloud-and-devops',
                        icon: <FaCogs />,
                    },
                    {
                        id: 'link-2',
                        label: 'Managed Odoo',
                        heading: 'Managed Odoo',
                        subheading: 'Odoo and cloud, run in your own account',
                        href: '/services/managed-services',
                        icon: <FaServer />,
                    },
                ],
            },
        ],
    },
    {
        id: 'nav-company',
        label: 'Company',
        type: 'simple',
        isDropdown: true,
        dropdown: [
            {
                id: 'company-1',
                label: 'Case Studies',
                href: '/case-studies',
            },
            {
                id: 'company-2',
                label: 'Blog',
                href: '/blogs',
            },
            {
                id: 'company-3',
                label: 'About Us',
                href: '/about-us',
            },
        ],
    },
]

function Navbar() {
    const stickyPages = []

    const pathName = usePathname()

    const isSticky = stickyPages.includes(pathName)

    // Pages with a dark hero behind the nav default to the dark (white-text)
    // theme. Everything else is a light page, so the nav reads as dark-on-glass.
    // Every /services/* SUBPAGE still renders a dark (#172554) hero, so those
    // opt into the dark theme via a prefix match. The /services index itself is
    // light now (see ServicesHero), and '/services' does not match the
    // '/services/' prefix, so it correctly falls through to the light default.
    // Nothing is left in the exact-path list: the home page, /about-us, and the
    // AI-First Engineering hub and its subpages all render light heroes now, so
    // they are deliberately absent. The list is kept so a future dark-hero page
    // has an obvious place to opt in.
    const darkHeroPages = []
    const darkHeroPrefixes = ['/services/']
    const defaultLight =
        !darkHeroPages.includes(pathName) &&
        !darkHeroPrefixes.some((prefix) => pathName?.startsWith(prefix))

    const [scrolled, setScrolled] = useState(false)
    const [overLight, setOverLight] = useState(defaultLight)

    useEffect(() => {
        setOverLight(defaultLight)

        // Sampled at most once per frame (in rAF): reading layout straight from
        // the scroll event / on mount forced a synchronous reflow each time.
        let raf
        const sample = () => {
            raf = null
            startTransition(() => setScrolled(window.scrollY > 24))

            // A section can opt into a theme for the nav via data-nav-theme.
            // The nav samples whatever band sits under it (~top 64px).
            const navY = 64
            const overlaps = (el) => {
                const r = el.getBoundingClientRect()
                return r.top < navY && r.bottom > 0
            }

            let light = defaultLight
            for (const el of document.querySelectorAll('[data-nav-theme="light"]')) {
                if (overlaps(el)) { light = true; break }
            }
            for (const el of document.querySelectorAll('[data-nav-theme="dark"]')) {
                if (overlaps(el)) { light = false; break }
            }
            // Also a transition: like setScrolled above, this can fire on the first
            // scroll while lazy components are still hydrating.
            startTransition(() => setOverLight(light))
        }
        const onScroll = () => {
            if (!raf) raf = requestAnimationFrame(sample)
        }

        onScroll()
        window.addEventListener('scroll', onScroll, { passive: true })
        return () => {
            window.removeEventListener('scroll', onScroll)
            if (raf) cancelAnimationFrame(raf)
        }
        // pathName is in the deps so the theme re-samples on every route change.
        // Without it, navigating between two light-default pages keeps a stale
        // overLight value (e.g. white nav text carried onto a light hero).
    }, [defaultLight, pathName])

    const navBg = scrolled
        ? overLight
            ? 'rounded-none border-b border-transparent bg-white/80 backdrop-blur-md'
            : 'rounded-none border-b border-transparent bg-[#04080f]/70 backdrop-blur-md'
        : overLight
        ? 'rounded-full border border-transparent bg-white/85 shadow-xl shadow-black/10 backdrop-blur-xl'
        : 'rounded-full border border-transparent bg-white/[0.08] shadow-2xl shadow-black/30 backdrop-blur-xl'

    const ctaColors = overLight
        ? 'bg-[#058BF0] text-white shadow-lg shadow-[#058BF0]/25 hover:bg-[#0470C4]'
        : 'bg-[#058BF0] text-white shadow-lg shadow-[#058BF0]/30 hover:bg-[#0470C4]'

    const Header = (
        <header
            className={`left-0 right-0 z-[100] transition-[top] duration-300 ease-out ${
                isSticky ? 'sticky' : 'fixed'
            } ${scrolled ? 'top-0' : 'top-4'}`}>
            <div
                className={`mx-auto transition-[max-width,width] duration-300 ease-out ${
                    scrolled ? 'w-full max-w-none' : 'w-[94%] max-w-[1500px]'
                }`}>
                <nav
                    className={`relative flex h-16 items-center transition-all duration-300 ease-out ${navBg}`}>
                    <div
                        className={`mx-auto flex h-full w-full items-center justify-between transition-[max-width,padding] duration-300 ease-out ${
                            scrolled ? 'max-w-[1600px] px-5 nav-md:px-8' : 'max-w-none px-5 nav-md:px-6'
                        }`}>
                        <Link href='/' className='block flex-shrink-0' aria-label='Cloudastra home'>
                            <Image
                                src={overLight ? CloudastraLogoBlack : CloudastraLogoWhite}
                                alt='Cloudastra'
                                loading='eager'
                                placeholder='blur'
                                className='w-[150px] transition-opacity duration-300 nav-md:w-[170px] xl:w-[200px]'
                            />
                        </Link>

                        {/* Centered nav links: logo stays left, Contact CTA stays
                            right (next sibling), so justify-between centers these. */}
                        <div className='hidden items-center nav-md:flex nav-md:flex-row nav-md:gap-0.5 xl:gap-1'>
                            {navbarData.map((data) => (
                                <NavItem
                                    key={'mainNav' + data.id}
                                    data={data}
                                    overLight={overLight}
                                    scrolled={scrolled}
                                />
                            ))}
                        </div>

                        <div className='hidden items-center nav-md:flex'>
                            {pathName === '/contact' ?
                                <span
                                    className={`inline-flex flex-shrink-0 cursor-default items-center gap-2 whitespace-nowrap rounded-lg px-4 py-2 text-sm font-semibold transition ${ctaColors}`}>
                                    <Phone className='h-3.5 w-3.5' strokeWidth={2.4} />
                                    Contact Us
                                </span>
                            :   <Link
                                    href='/contact?ref=navbar&utm_source=website&utm_medium=cta&utm_campaign=homepage&utm_content=home__navbar__contact_us'
                                    className={`group inline-flex flex-shrink-0 items-center gap-2 whitespace-nowrap rounded-lg px-4 py-2 text-sm font-semibold transition ${ctaColors}`}>
                                    <Phone
                                        className='h-3.5 w-3.5 transition-transform group-hover:rotate-12'
                                        strokeWidth={2.4}
                                    />
                                    Contact Us
                                </Link>
                            }
                        </div>

                        {/* Mobile: keep the Contact CTA visible as an icon-only
                            button beside the hamburger (the full-width labelled
                            one still lives inside the opened menu). */}
                        <div className='flex items-center gap-2 nav-md:hidden'>
                            {pathName === '/contact' ?
                                <span
                                    aria-label='Contact Us'
                                    className={`inline-flex h-10 w-10 flex-shrink-0 cursor-default items-center justify-center rounded-lg transition ${ctaColors}`}>
                                    <Phone className='h-4 w-4' strokeWidth={2.4} />
                                </span>
                            :   <Link
                                    href='/contact?ref=navbar&utm_source=website&utm_medium=cta&utm_campaign=homepage&utm_content=home__mobile_navbar__contact_us'
                                    aria-label='Contact Us'
                                    className={`group inline-flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg transition ${ctaColors}`}>
                                    <Phone
                                        className='h-4 w-4 transition-transform group-hover:rotate-12'
                                        strokeWidth={2.4}
                                    />
                                </Link>
                            }
                            <MobileNav navbarData={navbarData} overLight={overLight} />
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )

    return Header
}

export default Navbar
